export default {"src":"/_next/static/image/public/images/flags/flag_64.20e6947415421783cef4d58da6c5f426.svg","height":16,"width":24};